import { ExternalLink } from 'lucide-react';
import { publishedProjects } from '@/data/projects';
import { profile } from '@/data/profile';
import { Container, SectionHeading } from '@/components/common/SectionHeading';
import { AnchorButton } from '@/components/common/Button';
import { ProjectRepoIcon } from '@/components/common/SocialIcon';
import styles from './Projects.module.css';

export function Projects() {
  const hasProjects = publishedProjects.length > 0;

  return (
    <section id="projects" className="section" aria-labelledby="projects-heading">
      <Container>
        <SectionHeading
          id="projects-heading"
          eyebrow="Projects"
          title="Selected work"
          description={
            hasProjects
              ? 'A selection of products and systems I have helped design and deliver.'
              : 'Project case studies will appear here. Until then, explore public repositories on GitHub.'
          }
        />

        {hasProjects ? (
          <div className={styles.grid}>
            {publishedProjects.map((project) => (
              <article key={project.id} className={styles.card}>
                {project.image ? (
                  <img
                    src={project.image}
                    alt=""
                    className={styles.image}
                    loading="lazy"
                    width={640}
                    height={360}
                  />
                ) : null}
                <div className={styles.body}>
                  <div className={styles.meta}>
                    <span>{project.category}</span>
                    <span>{project.status}</span>
                  </div>
                  <h3 className={styles.title}>{project.title}</h3>
                  <p className={styles.description}>{project.shortDescription}</p>
                  <ul className={styles.tech}>
                    {project.technologies.map((tech) => (
                      <li key={tech}>{tech}</li>
                    ))}
                  </ul>
                  <div className={styles.links}>
                    {project.liveUrl ? (
                      <a href={project.liveUrl} target="_blank" rel="noopener noreferrer">
                        Live site
                        <ExternalLink size={14} aria-hidden="true" />
                      </a>
                    ) : null}
                    {project.repositoryUrl ? (
                      <a href={project.repositoryUrl} target="_blank" rel="noopener noreferrer">
                        Repository
                        <ProjectRepoIcon size={14} />
                      </a>
                    ) : null}
                  </div>
                </div>
              </article>
            ))}
          </div>
        ) : (
          <div className={styles.empty}>
            <p>
              No public project case studies are listed yet. Real projects should be added in{' '}
              <code>src/data/projects.ts</code>.
            </p>
            <AnchorButton href={profile.githubUrl} target="_blank" rel="noopener noreferrer">
              <ProjectRepoIcon size={18} />
              View GitHub profile
            </AnchorButton>
          </div>
        )}
      </Container>
    </section>
  );
}
